import { Button } from '@casavo/base-ui'
import useTranslation from 'next-translate/useTranslation'
import React from 'react'

import { GeoFilter } from '@/types/filter'

import { geoFilterModalFooter } from './styles.css'

type Props = {
  activeFilters: GeoFilter[]
  onSubmit: () => void
}

const Footer: React.FC<Props> = (props) => {
  const { t } = useTranslation()

  return (
    <footer className={geoFilterModalFooter}>
      <Button
        data-testid="zone-filter-submit"
        label={t('zones:search')}
        minWidth={225}
        styleVariant="secondary"
        onClick={props.onSubmit}
      />
    </footer>
  )
}

export default Footer
